<span class="qa-bibliographic-resource-type">
  <ng-container [ngSwitch]="resourceType">
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Article"
      i18n="@@bibliographicResourceType-label-article"
      >Article</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.AudioDocument"
      i18n="@@bibliographicResourceType-label-audioDocument"
      >Audio Document</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.AudioVisualDocument"
      i18n="@@bibliographicResourceType-label-audioVisualDocument"
      >Audio-visual document</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Book"
      i18n="@@bibliographicResourceType-label-book"
      >Book</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Chapter"
      i18n="@@bibliographicResourceType-label-chapter"
      >Chapter</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Document"
      i18n="@@bibliographicResourceType-label-document"
      >Document</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Image"
      i18n="@@bibliographicResourceType-label-image"
      >Image</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Journal"
      i18n="@@bibliographicResourceType-label-journal"
      >Journal</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.LegalCaseDocument"
      i18n="@@bibliographicResourceType-label-legalCaseDocument"
      >Legal Case Document</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.LegalDocument"
      i18n="@@bibliographicResourceType-label-legalDocument"
      >Legal Document</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Legislation"
      i18n="@@bibliographicResourceType-label-legislation"
      >Legislation</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Score"
      i18n="@@bibliographicResourceType-label-musicScore"
      >Music Score</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Page"
      i18n="@@bibliographicResourceType-label-page"
      >Page</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Presentation"
      i18n="@@bibliographicResourceType-label-presentation"
      >Presentation</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Proceedings"
      i18n="@@bibliographicResourceType-label-proceedings"
      >Proceedings</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Thesis"
      i18n="@@bibliographicResourceType-label-thesis"
      >Thesis</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Video"
      i18n="@@bibliographicResourceType-label-video"
      >Video</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Webpage"
      i18n="@@bibliographicResourceType-label-webpage"
      >Webpage</ng-container
    >
    <ng-container
      *ngSwitchCase="BibliographicResourceType.Website"
      i18n="@@bibliographicResourceType-label-website"
      >Website</ng-container
    >
    <ng-container *ngSwitchDefault>{{ resourceType }}</ng-container>
  </ng-container>
</span>
